
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import UpLoadProfile from '../../../../components/UpLoadProfile/index'
import { editUserInfo, loginOut } from '../../../../service/getData'

export default {
    mounted() {
         this.$store.dispatch('SET_TITLE', '个人信息')
    },
    components: {
        Group,
        Cell,
        Actionsheet,
        XButton,
        'upload-img': UpLoadProfile
    },
    data() {
        return {
            showsex: false,
            sexmenus: {
                man: '男',
                women: '女'
            },
            showprofile: false,
            profilemenus: [{
                label: '<label style="display: inline-block;width: 100%;" for="upload_input">选择照片</label>'
            }],
            showWithdrew: true,
            showMessage: true
        }
    },
    methods: {
        choiceSex() {
            this.showsex = true;
        },
        changeSex(menuKey) {
            var self = this;
            var nickname = self.$store.state.nickname;
            if(menuKey === 'man') {
                var gender = 1;
            }else {
                var gender = 2;
            }
            editUserInfo( nickname, gender ).then(function(result) {
                if(result.data.status){
                    var gender= result.data.userExt.gender
                    if(1 == gender){
                        self.$store.dispatch('SET_USER_SEX_MAN');
                    }else if(2 == gender){
                        self.$store.dispatch('SET_USER_SEX_WOMEN');
                    }
                }
            }).catch(function(err) {
                console.log(err)
            })
        },
        choiceProfile() {
            this.showprofile = true;
        },
        closeProfile() {
            this.showprofile = false;
        },
        link() {
            var self = this
            this.$vux.confirm.show({
                title: '提示',
                content: '您确定要退出吗',
                onConfirm() {
                    loginOut().then(function(res) {
                        if(res.data.status) {
                            self.$store.dispatch('SET_USER_LOGIN_OUT');
                            self.$store.dispatch('SET_AVATAR','/style/imgs/mrtx.png');
                            self.$store.dispatch('SET_NICKNAME','您尚未登录，点击登录');
                            self.$store.dispatch('SET_NAME','您还没有书堆号');
                            self.$router.go(-1)
                        }
                    }).catch(function(err) {
                        console.log(err)
                    })
                }
            })
        }
    },
    computed: {
        sex() {
            return this.$store.state.userSex;
        },
        avatar() {
            return this.$store.state.avatar
        },
        nickname() {
            return this.$store.state.nickname
        },
        mobile() {
            var mobile = this.$store.state.mobile
            var newmobile = mobile.substr(0,3)+"****"+mobile.substr(7)
            return newmobile
        }
    }
}




// WEBPACK FOOTER //
// ./src/pages/personalcenter/children/personalInfo/index.vue